export enum AssetType {
  AURORA = 'aurora',
  DEVICE = 'device',
  RUUVI_TAG = 'ruuvi_tag'
}
